// Helpers tipados pra disparar eventos no tracker do Trakd
// (`window.Track.*`, exposto pelo bundle UMD em cdn.trakd.pro/v1/track.js).
//
// O tracker (packages/tracker) expõe helpers nominais (`viewContent`,
// `initiateCheckout`, `lead`, etc) em `globalThis.Track` — não há um `track`
// genérico. Esses helpers internamente chamam `event(name, payload)` que
// monta o envelope completo (pixelId, sessionId, fbp/fbc, click_ids, etc).
//
// Silently no-op se:
// - SSR (no window)
// - Tracker ainda não inicializou (timing do `<Script afterInteractive>` —
//   se user clica antes do JS carregar, `window.Track` é undefined)
// - Helper específico não disponível (defensivo contra versões antigas)
// - Exceção interna (tracking nunca pode quebrar a UX)

interface TrakdGlobal {
  viewContent?: (payload: Record<string, unknown>) => void;
  initiateCheckout?: (payload: Record<string, unknown>) => void;
  lead?: (payload: Record<string, unknown>) => void;
}

export interface ViewContentPayload {
  content_name?: string;
  content_category?: string;
  content_ids?: string[];
  value?: number;
  currency?: string;
}

export interface InitiateCheckoutPayload {
  content_name?: string;
  content_category?: string;
  value?: number;
  currency?: string;
  num_items?: number;
}

export interface LeadPayload {
  content_name?: string;
  content_category?: string;
  value?: number;
  currency?: string;
}

function trakd(): TrakdGlobal | null {
  if (typeof window === 'undefined') return null;
  const t = (window as unknown as { Track?: TrakdGlobal }).Track;
  return t ?? null;
}

export function viewContent(payload: ViewContentPayload = {}): void {
  try {
    trakd()?.viewContent?.(payload as Record<string, unknown>);
  } catch {
    // silent: tracking não deve quebrar UX
  }
}

export function initiateCheckout(payload: InitiateCheckoutPayload = {}): void {
  try {
    trakd()?.initiateCheckout?.(payload as Record<string, unknown>);
  } catch {
    // silent: tracking não deve quebrar UX
  }
}

export function lead(payload: LeadPayload = {}): void {
  try {
    trakd()?.lead?.(payload as Record<string, unknown>);
  } catch {
    // silent: tracking não deve quebrar UX
  }
}
